import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ClientAuthService } from './services/auth/client-auth.service';

@Injectable({
  providedIn: 'root'
})
export class ClientGuard implements CanActivate {

  constructor(private authService: ClientAuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isLoggedIn()) {
      const userRole = this.authService.getRoleFromToken() ?? "";

      if (userRole == 'Client') {
        return true;
      }

      // You don't have access to this portal, log you out.
      this.authService.logOut();
      return false;
    } else {
      // save return url if we have one
      const existingReturnUrl = sessionStorage.getItem('returnUrl');

      if (state.url != '/dashboard' && 
        !existingReturnUrl && 
        !state.url?.startsWith('/callback')) {
        const returnUrl = state.url;
        sessionStorage.setItem('returnUrl', returnUrl);
      } 

      // this will just force a log in.
      return true;
    }
  }
}